import { IdentifierCode, type ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import {
  type PersonContact,
  type PersonGeneral,
  personContactFieldSchemas,
  personGeneralFieldSchemas,
} from '../person';
import type { CreateNextOfKin } from './schema';

const identifierCodeSchema = yup
  .string()
  .oneOf([
    IdentifierCode.southAfricanIdNumber,
    IdentifierCode.passportNumber,
    IdentifierCode.namibianIdNumber,
  ])
  .optional();

export const nextOfKinGeneralSchema = yup.object<ObjectType<PersonGeneral>>({
  ...personGeneralFieldSchemas,
  identifierCode: identifierCodeSchema,
  identifierValue: yup.string().optional(),
  birthDate: yup.string().optional(),
});

export const nextOfKinContactSchema = yup.object<ObjectType<PersonContact>>({
  ...personContactFieldSchemas,
  telecomEmail: yup.string().lowercase().email().optional(),
});

export const nextOfKinSchema = yup.object<ObjectType<CreateNextOfKin>>({
  contact: nextOfKinContactSchema,
  general: nextOfKinGeneralSchema,
});
